"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosService = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const axios_1 = __importDefault(require("axios"));
const httpService_1 = require("./httpService");
class AxiosService {
    constructor(baseUrl, formAuthorization) {
        this.baseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
        this.authorizationStatus = httpService_1.AuthorizationStatus.IDLE;
        this.instance = this.createAxiosInstance();
        if (formAuthorization === null || formAuthorization === void 0 ? void 0 : formAuthorization.username) {
            this.formAuthorization = formAuthorization;
        }
        else {
            if (formAuthorization) {
                this.modifyHeader({
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${formAuthorization}`,
                });
                this.authorizationStatus = httpService_1.AuthorizationStatus.ALLOWED;
            }
            else {
                this.authorizationStatus = httpService_1.AuthorizationStatus.DISABLED;
            }
        }
    }
    createAxiosInstance() {
        return axios_1.default.create({ timeout: 0, baseURL: this.baseUrl });
    }
    modifyHeader(apiRestHeaders) {
        Object.entries(apiRestHeaders).forEach((entry) => {
            const [key, value] = entry;
            this.instance.defaults.headers[key] = value;
        });
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.authorizationStatus == httpService_1.AuthorizationStatus.IDLE) {
                const response = yield this.post('authenticate', this.formAuthorization).catch((error) => {
                    throw error;
                });
                if (response.status == 200) {
                    this.modifyHeader({
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        Authorization: `Bearer ${response.data}`,
                    });
                    this.authorizationStatus = httpService_1.AuthorizationStatus.ALLOWED;
                }
                else {
                    this.authorizationStatus = httpService_1.AuthorizationStatus.DENIED;
                }
            }
        });
    }
    post(url, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.instance
                .post(url, data)
                .then((response) => {
                return {
                    data: response.data,
                    status: response.status,
                };
            })
                .catch((error) => {
                throw error;
            });
        });
    }
    get(url) {
        return __awaiter(this, void 0, void 0, function* () {
            let httpResponse = { status: -1, data: null };
            yield this.getToken();
            if (this.authorizationStatus == httpService_1.AuthorizationStatus.ALLOWED ||
                this.authorizationStatus == httpService_1.AuthorizationStatus.DISABLED) {
                httpResponse = yield this.instance.get(url).catch((error) => {
                    throw error;
                });
            }
            return Promise.resolve(httpResponse);
        });
    }
    getBlob(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                url: `${this.baseUrl}${url}`,
                method: 'get',
                responseType: 'blob',
            };
            const response = yield axios_1.default.request(config);
            return response.data;
        });
    }
}
exports.AxiosService = AxiosService;
//# sourceMappingURL=axiosServices.js.map